import React, { useState } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { Grid } from "@mui/material";

const DynamicDropdowns = (props) => {
  const [selections, setSelections] = useState({});

  const getOptionsForLevel = (level) => {
    // First level - always return roles
    if (level === 0) {
      return props.data.roles || [];
    }

    const selectedRole = props.data.roles.find(
      (role) => role.id === selections.role,
    );
    // console.log('Selected role data:', {
    //     role: selectedRole,
    //     employees: selectedRole?.employees,
    //     level,
    //     selections
    // });
    if (!selectedRole) return [];

    // For SALES_REPRESENTATIVE, second level should show employees

    if (selectedRole.id === "SALES_REPRESENTATIVE") {
      const employees = selectedRole.employees || [];
      // console.log('SALES_REP employees:', employees);
      return employees;
    }

    // For SOLUTION_PROVIDER
    if (level === 1) {
      return selectedRole.providers?.map((p) => p.providerDetails) || [];
    }

    if (level === 2) {
      // Third level - return employees of selected provider
      const selectedProvider = selectedRole.providers?.find(
        (p) => p.providerDetails.id === selections.provider,
      );
      return selectedProvider?.providerDetails.employees || [];
    }
    return [];
  };

  const handleChange = (level, value) => {
    const newSelections = { ...selections };
    const levelKey = props.structure[level].key;

    newSelections[levelKey] = value;

    for (let i = level + 1; i < props.structure.length; i++) {
      newSelections[props.structure[i].key] = "";
    }

    setSelections(newSelections);

    // When employee is selected, emit the complete reviewer data
    if (levelKey === "employee" && value) {
      const selectedRole = props.data.roles.find(
        (role) => role.id === selections.role,
      );
      let selectedEmployee;

      if (selectedRole.id === "SALES_REPRESENTATIVE") {
        selectedEmployee = selectedRole.employees.find(
          (emp) => emp.id === value,
        );
      } else {
        const selectedProvider = selectedRole.providers?.find(
          (p) => p.providerDetails.id === selections.provider,
        );
        selectedEmployee = selectedProvider?.providerDetails.employees.find(
          (emp) => emp.id === value,
        );
      }

      if (selectedEmployee) {
        const selectedProvider = selections.provider
          ? props.data.roles
              .find((r) => r.id === selections.role)
              .providers.find(
                (p) => p.providerDetails.id === selections.provider,
              ).providerDetails
          : null;

        const reviewerData = {
          role: selectedRole.name,
          employee: selectedEmployee.name,
          employeeId: value,
          roleId: selections.role,
        };
        if (selectedRole.id !== "SALES_REPRESENTATIVE" && selectedProvider) {
          reviewerData.providerName = selectedProvider.name;
          reviewerData.providerId = selectedProvider.id;
        }

        props.onReviewerSelected && props.onReviewerSelected(reviewerData);
        setSelections({}); // Reset selections after adding
      }
    }
  };

  return (
    // <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', alignItems: 'center', width: '100%' }}>
    // </div>
    <Grid container spacing={1}>
      {props.structure.map((level, index) => {
        const selectedRole = props.data.roles.find(
          (role) => role.id === selections.role,
        );
        const isSalesRep = selectedRole?.id === "SALES_REPRESENTATIVE";

        if (isSalesRep && level.key === "provider") {
          return null;
        }
        const options = getOptionsForLevel(index);

        // Skip provider level for SALES_REPRESENTATIVE
        if (
          selectedRole?.id === "SALES_REPRESENTATIVE" &&
          level.key === "provider"
        ) {
          return null;
        }

        const shouldRender =
          index === 0 || // Always render first level
          (selectedRole?.id === "SALES_REPRESENTATIVE" &&
            level.key === "employee" &&
            selections.role) ||
          (selectedRole?.id === "SOLUTION_PROVIDER" && options.length > 0);

        return (
          shouldRender && (
            <Grid
              item
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <FormControl
                key={level.key}
                className="custom-select-input"
                size={"small"}
                variant={"outlined"}
              >
                <InputLabel>{level.label}</InputLabel>
                <Select
                  native
                  value={selections[level.key] || ""}
                  onChange={(e) => handleChange(index, e.target.value)}
                  label={level.label}
                >
                  <option value="" disabled></option>
                  {options.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )
        );
      })}
    </Grid>
  );
};

export default DynamicDropdowns;
